// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7216) return "static/chunks/7216-56dfcaf2a84f3ad9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "54c4c0fe3181ad8f" + ".js";
};